import request from '@/utils/request'
import { getApiHeader,getToken} from '@/api/auth'
import { getCloudUploadUris } from '@/utils/cloudServer'



export function login (parameter) {
  let uri = "api/v1/user/login"
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: getApiHeader(parameter,uri),
    skipGlobalErrorMessage: true,
  })
}
export function getCode (parameter) {
  let uri = "api/v1/code/sms"
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: getApiHeader(parameter,uri),
  })
}
export function sendSmsCode (parameter) {
  let uri = "api/v1/code/sms"
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: getApiHeader(parameter,uri),
    skipGlobalErrorMessage: true,
  })
}
export function sendEmailCode (parameter) {
  let uri = "api/v1/code/email"
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: getApiHeader(parameter,uri),
    skipGlobalErrorMessage: true,
  })
}
export function checkCode (parameter) {
  let uri = "api/v1/user/checkCode"
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: getApiHeader(parameter,uri),
    skipGlobalErrorMessage: true,
  })
}
export function resetPassword (parameter) {
  let uri = "api/v1/user/resetPassword"
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: getApiHeader(parameter,uri),
    skipGlobalErrorMessage: true,
  })
}
export function updateUser (parameter) {
  let uri = "api/v1/user/update"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    skipGlobalErrorMessage: true,
  })
}
export function getCloudStatus (parameter, config = {}) {
  let uri = "api/v1/user/getCloudStatus"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? false : config.skipGlobalErrorMessage,
  })
}
export function checkCloudPassword (parameter, config = {}) {
  let uri = "api/v1/user/checkCloudPassword"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getRootFolder (parameter, config = {}) {
  let uri = "api/v1/resourceSync/getRootFolder"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? false : config.skipGlobalErrorMessage,
  })
}
export function getHistoryPage (parameter, config = {}) {
  let uri = "api/v1/history/getPage"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
function normalizeResourceSyncPageParameter (parameter = {}) {
  const payload = Object.assign({}, parameter || {})
  if (payload.isDelete === undefined || payload.isDelete === null || payload.isDelete === '') {
    payload.isDelete = -1
  }
  if (payload.sortField == 'created_at') {
    payload.sortField = 'creation_time'
  } else if (payload.sortField == 'updated_at') {
    payload.sortField = 'last_modified_time'
  }
  return payload
}
export function getPaperSyncList (parameter, config = {}) {
  let uri = "api/v1/resourceSync/getPage"
  parameter = normalizeResourceSyncPageParameter(parameter)
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: true,
  })
}
export function getLearningSyncList (parameter, config = {}) {
  let uri = "api/v1/resourceSync/getPage"
  parameter = normalizeResourceSyncPageParameter(parameter)
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: true,
  })
}
export function searchResourceSync (parameter, config = {}) {
  let uri = "api/v1/resourceSync/search"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getPaperSyncDetail (parameter, config = {}) {
  let uri = "api/v1/paperSync/get"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getLearningSyncDetail (parameter, config = {}) {
  let uri = "api/v1/learningSync/get"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getResourceDailySyncList (parameter, config = {}) {
  let uri = "api/v1/resourceDailySync/getList"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getResourceDailySyncDateList (parameter, config = {}) {
  let uri = "api/v1/resourceDailySync/getDateList"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getMemoSyncDetail (parameter, config = {}) {
  let uri = "api/v1/memoSync/get"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getMeetingSyncDetail (parameter, config = {}) {
  let uri = "api/v1/meetingSync/get"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
export function getKnowledgeBaseSyncList (parameter, config = {}) {
  let uri = "api/v1/resourceSync/getPage"
  parameter = normalizeResourceSyncPageParameter(parameter)
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: true,
  })
}
export function getKnowledgeBaseSyncDetail (parameter, config = {}) {
  let uri = "api/v1/knowledgeBaseSync/get"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
function postResourceSyncAction (uri, parameter, config = {}) {
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}
function isMissingResourceSyncAction (error) {
  const status = error && error.response ? error.response.status : 0
  return status == 404 || status == 405
}
export function restoreResourceSyncItems (parameter, config = {}) {
  return postResourceSyncAction("api/v1/resourceSync/restore", parameter, config).catch(error => {
    if (isMissingResourceSyncAction(error)) {
      return postResourceSyncAction("api/v1/resourceSync/recover", parameter, config)
    }
    return Promise.reject(error)
  })
}
export function sendSmsCodeAuth (parameter) {
  let uri = "api/v1/code/sms"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function sendEmailCodeAuth (parameter) {
  let uri = "api/v1/code/email"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function checkCodeAuth (parameter) {
  let uri = "api/v1/user/checkCode"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function resetPasswordAuth (parameter) {
  let uri = "api/v1/user/changePassword"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function sendFiled (parameter) {
  let uri = "api/v1/file/send"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}

export function refreshLogin (parameter) {
  let uri = "api/v1/user/refreshLogin"
  let headers = getApiHeader(parameter,uri)
  console.info("headersheaders",headers)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
    skipGlobalErrorMessage: true,
  })
}

export function getDeviceList (parameter) {
  let uri = "api/v1/userDevice"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function getTimeId (parameter, config = {}) {
  let uri = "api/v1/file/cacheTime"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'get',
    data:parameter,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? false : config.skipGlobalErrorMessage,
  })
}
export function updateFileCacheTime (parameter) {
  let uri = "api/v1/file/cacheTime"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function getAreaCode (parameter) {
  let uri = "api/v1/nation"
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: getApiHeader(parameter,uri),
    skipGlobalErrorMessage: true,
  })
}



export function initUploadFile (parameter,deviceId) {
  let uri = "api/v2/upload/init"
  let headers = getApiHeader(parameter,uri,deviceId)
  headers.Authorization = "Bearer "+getToken()

  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function completeUploadFile (parameter,deviceId) {
  let uri = "api/v2/upload/complete"
  let headers = getApiHeader(parameter,uri,deviceId)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}
export function abortUploadFile (parameter,deviceId) {
  let uri = "api/v2/upload/abort"
  let headers = getApiHeader(parameter,uri,deviceId)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}

function postCloudUploadAction(uri, parameter, config = {}) {
  const payload = parameter || {}
  let headers = getApiHeader(payload, uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data: payload,
    headers: headers,
    signal: config.signal,
    cloudServerKey: config.serverKey,
    skipGlobalErrorMessage: config.skipGlobalErrorMessage === undefined ? true : config.skipGlobalErrorMessage,
  })
}

export function initCloudUploadFile (parameter, config = {}) {
  const uri = getCloudUploadUris(config.serverKey).init
  return postCloudUploadAction(uri, parameter, config)
}

export function completeCloudUploadFile (parameter, config = {}) {
  const uri = getCloudUploadUris(config.serverKey).complete
  return postCloudUploadAction(uri, parameter, config)
}

export function importResourceSync (parameter, config = {}) {
  return postResourceSyncAction("api/v1/resourceSync/import", parameter, config)
}

export function mkdir (parameter) {
  return request({
    url: "file/mkdir",
    method: 'post',
    data: parameter
  })
}

export function list (parameter) {
  let uri = "api/v2/file/list"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}

export function fileRemove (parameter) {
  let uri = "api/v1/file/del"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data:parameter,
    headers: headers,
  })
}

export function rename (parameter) {
  return request({
    url: "file/rename",
    method: 'post',
    data: parameter
  })
}

export function mvcp (parameter) {
  return request({
    url: "file/mvcp",
    method: 'post',
    data: parameter
  })
}

export function uploadCheck (parameter) {
  return request({
    url: "upload/check",
    method: 'post',
    data: parameter
  })
}

export function uploadFile (parameter) {
  let uri = "api/v1/file/uploadAll"
  console.info("uri",uri)
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data: parameter,
    headers: headers,

  })
}
export function getFileTypeList (parameter) {
  let uri = "api/v1/file/fileType"
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data: parameter,
    headers: headers,

  })
}

export function downloadFile (parameter) {
  let uri = "api/v2/file/path"
  console.info("uri",uri)
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data: parameter,
    headers: headers,

  })
}
export function getFileExt (parameter) {
  let uri = "api/v1/file/ext"
  console.info("uri",uri)
  let headers = getApiHeader(parameter,uri)
  headers.Authorization = "Bearer "+getToken()
  return request({
    url: uri,
    method: 'post',
    data: parameter,
    headers: headers,

  })
}

export function sharedList (parameter) {
  return request({
    url: "shared/list",
    method: 'post',
    data: parameter
  })
}

export function sharedCreate (parameter) {
  return request({
    url: "shared/create",
    method: 'post',
    data: parameter
  })
}

export function sharedInfo (parameter) {
  return request({
    url: "shared/info",
    method: 'post',
    data: parameter
  })
}

export function sharedPath (parameter) {
  return request({
    url: "shared/path",
    method: 'post',
    data: parameter
  })
}

export function sharedDownload (parameter) {
  return request({
    url: "shared/download",
    method: 'post',
    responseType:"blob",
    data: parameter
  })
}

export function sharedCancel (parameter) {
  return request({
    url: "shared/cancel",
    method: 'post',
    data: parameter
  })
}
